import { Button } from '../ui/button';
import { ArrowRight, Rocket } from 'lucide-react';
import { WA_URL } from '../../lib/wa';

const CATEGORIES = ['Spices', 'Snacks', 'Staples', 'Dairy', 'Edible Oils'];
// Repeat for a seamless marquee loop
const TICKER_ITEMS = [...CATEGORIES, ...CATEGORIES, ...CATEGORIES.slice(0, 4)];

export const Hero = () => (
  <section className="relative py-20 md:py-32 overflow-hidden">
    <div className="absolute inset-0 z-0">
      <img
        src="https://images.unsplash.com/photo-1703977883249-d959f2b0c1ae"
        alt="Cargo port at dusk"
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-[#004aad]/70"></div>
      <div className="absolute inset-0 shimmer-bg"></div>
    </div>

    <div className="container mx-auto px-6 relative z-10">
      <div className="max-w-4xl mx-auto text-center">
        <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-orange-500 to-red-500 text-white px-5 py-2 rounded-full text-sm font-bold mb-4 animate-pulse">
          <span>🔥</span>
          <span>Now Onboarding Q2 2026 Partners</span>
        </div>
        <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-medium mb-6">
          <Rocket className="h-4 w-4" />
          <span>Launching Indian Brands Globally</span>
        </div>
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight fade-in-up">
          We Don't Just Move Containers.
          <span className="block mt-2">We Launch Brands.</span>
        </h1>
        <p className="text-xl text-white/90 mb-10 leading-relaxed max-w-2xl mx-auto">
          Your market-entry + distribution + brand-building partner for launching Indian FMCG brands into Australia & New Zealand.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
          <Button asChild size="lg" className="bg-white hover:bg-gray-100 text-[#004aad] text-lg px-8 py-6 transition-all duration-300 pulse-cta font-bold" data-testid="hero-launch-brand-btn">
            <a href={WA_URL} target="_blank" rel="noopener noreferrer">
              Launch Your Brand
              <ArrowRight className="ml-2 h-5 w-5" />
            </a>
          </Button>
          <Button asChild size="lg" variant="outline" className="text-lg px-8 py-6 border-2 border-white text-white hover:bg-white hover:text-[#004aad] transition-all duration-300" data-testid="hero-learn-more-btn">
            <a href={WA_URL} target="_blank" rel="noopener noreferrer">
              Learn More
            </a>
          </Button>
        </div>

        <div className="mt-8">
          <p className="text-white/60 text-sm mb-3">Categories we launch across Australia & New Zealand</p>
          <div className="ticker-wrapper bg-white/10 backdrop-blur-sm py-3 rounded-full">
            <div className="ticker-content">
              {TICKER_ITEMS.map((cat, i) => (
                <span key={i} className="text-white font-semibold mx-6">✦ {cat}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);
